import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ChatList } from '@/types/Chat';
import { axios2 } from '@/lib/axiosData';

export const getChatlist = (active: string): Promise<ChatList[]> => {
  console.log('active', active);
  if (active === 'client') {
    return axios2.get('customer-api/customer-converstation-listing');
  } else if (active === 'agency') {
    return axios2.get('customer-api/customer-agency-converstation-listing');
  }
};

type QueryFnType = typeof getChatlist;

type UseChatOptions = {
  config?: QueryConfig<QueryFnType>;
  active?: string;
};

export const useGetChatList = ({ active, config }: UseChatOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['chat-list'],
    queryFn: () => getChatlist(active),
  });
};
